 
import { Button, CIActionBtnGroup, CITooltip, Input, MyIcon } from 'ccs-ui-components';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { specialCharacter, nonSpaceCharacter, SERVICE_OPERATION_MAXLENGTH } from '../../../../../../../constants';
import { IQueryPathParam } from '../../../../../../../models';
import { useSelector } from '../../../../../../../store/AppStore';

import classes from './ServiceOpsQueryItem.module.scss';

interface IQueryPathParamProps {
  index: number,
  queryParamKey: string,
  value: string,
  isEdit: boolean | undefined,
  updateQuery: (obj: IQueryPathParam) => void;
  deleteQuery: any;
  isView: boolean;
  queryList?: IQueryPathParam[];
}
const ServiceOperationQueryItem = ({ index, queryParamKey, value, isEdit, updateQuery, deleteQuery, isView, queryList }: IQueryPathParamProps) => {
  const [queryKey, setQueryKey] = useState(queryParamKey);
  const [queryValue, setQueryValue] = useState(value);
  const [editClicked, setEditClicked] = useState(isEdit);
  const [oldKey, setOldKey] = useState('');
  const [oldValue, setOldVaue] = useState('');
  const [error, setError] = useState('');
  const [valueError, setValueError] = useState('');
  const [isQueryKeyValid, setIsQueryKeyValid] = useState<boolean>(true);
  const [isQueryValueValid, setIsQueryValueValid] = useState<boolean>(true);

  /**
  Validating the key and value input in query params
  */
  let keyError;

  const keyValidation = (e: string) => {
    if (specialCharacter.test(e) && e.length <= 500) {
      setIsQueryKeyValid(true);
    } else {
      setIsQueryKeyValid(false);
      if (e.length > 500) {
        keyError = translate(
          'service_operation_form_validation_component.err_max_char_limit',
          { replace: { maxChars: 500 } }
        );
        setError(keyError);
      } else {
        keyError = SERVICE_OPERATIONS_ERRORS.invalidKey;
        setError(keyError);
      }
    }
  };
  const { importStatus } = useSelector(
    (state) => state.serviceOperationReducer
  );
  // Form validation for query key on import
  useEffect(() => {
    keyValidation(queryKey);
  }, [importStatus]);

  const isUpdateQueryBtnEnabled = () => !!(isQueryKeyValid && queryKey && isQueryValueValid && queryValue);

  const valueValidation = (e: string) => {
    let error;
    if (nonSpaceCharacter.test(e) && e.length <= 500) {
      setIsQueryValueValid(true);
    } else {
      setIsQueryValueValid(false);
      if (e.length > 500) {
        error = translate(
          'service_operation_form_validation_component.err_max_char_limit',
          { replace: { maxChars: 500 } }
        );
        setValueError(error);
      } else {
        error = SERVICE_OPERATIONS_ERRORS.invalidValue;
        setValueError(error);
      }
    }
  };

  useEffect(() => { valueValidation(queryValue); }, [queryValue]);

  const onQueryChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    keyValidation(event.target.value);
    setQueryKey(event.target.value);
  };

  const onQueryValueChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    valueValidation(event.target.value);
    setQueryValue(event.target.value);
  };
  /**
   * Checks if a query key exists or not
   */
  useEffect(() => {
    let status = false;
    if (queryList) {
      status = queryList.some((item, itemIndex) => item.key === queryKey && itemIndex !== index);
    }
    if (status) {
      setIsQueryKeyValid(false);
      keyError = SERVICE_OPERATIONS_ERRORS.queryKeyExists;
      setError(keyError);
    } else if (!status && specialCharacter.test(queryKey) && queryKey.length < parseInt(SERVICE_OPERATION_MAXLENGTH.queryPathParamMaxLength, 10)) {
      setIsQueryKeyValid(true);
      keyError = '';
    }
  }, [queryKey, queryList]);

  const onEditQueryHandler = () => {
    setEditClicked(true);
    setOldKey(queryKey);
    setOldVaue(queryValue);
  };

  const onCancelQueryHandler = () => {
    setEditClicked(false);
    setQueryKey(oldKey);
    setQueryValue(oldValue);
  };

  const onUpdateQueryHandler = (index: number) => {
    setEditClicked(false);
    updateQuery({ key: queryKey, value: queryValue, index });
  };

  const onDeleteQueryHandler = (index: number) => {
    deleteQuery(index);
  };

  const { t: translate } = useTranslation();

  const SERVICE_OPERATIONS_ERRORS = {
    serviceOperation: translate('service_operation_details_form.serviceOperation'),
    serviceOperationExist: translate('service_operation_details_form.serviceOperationExist'),
    serviceOperationDuplicateError: translate('service_operation_details_form.serviceOperationDuplicateError'),
    operationURL: translate('service_operation_details_form.operationURL'),
    invalidKey: translate('service_operation_details_form.invalidKey'),
    invalidValue: translate('service_operation_details_form.invalidValue'),
    queryKeyExists: translate('service_operation_details_form.queryKeyExists'),
    headerKeyExists: translate('service_operation_details_form.headerKeyExists')
  };

  return (
    <div className={classes['query-list']}>
      <Row className={classes['param-body']}>
        <Col sm={5}>{editClicked ? (
          <div>
            <div className={classes['input-on-edit']}><Input
              name="queryParamKey"
              label=""
              placeholder={String(
                translate('service_operation_details_form.query_param_key')
              )}
              onChange={onQueryChangeHandler}
              value={queryKey}
              data-testid="query-key-change"
              error={!isQueryKeyValid}
              errorTxt={error}
              maxLength={Number(SERVICE_OPERATION_MAXLENGTH.queryPathParamMaxLength)}
            />
            </div>
          </div>) : <div className={classes['table-items']}><CITooltip placement="right" message={queryKey}><p className={classes['ops-item-tooltip']} data-testid="row-querykey">{queryKey}</p></CITooltip></div>}
        </Col>
        <Col sm={5}>{editClicked ? (
          <div>
            <div className={classes['input-on-edit']}><Input
              name="queryParamValue"
              label=""
              placeholder={String(
                translate('service_operation_details_form.query_param_value')
              )}
              onChange={onQueryValueChangeHandler}
              value={queryValue}
              error={!isQueryValueValid}
              errorTxt={valueError}
              maxLength={Number(SERVICE_OPERATION_MAXLENGTH.queryPathParamMaxLength)}
              data-testid="query-value-change"
            />
            </div>
          </div>) : <div className={classes['table-items']}><CITooltip placement="right" message={queryValue}><p className={classes['ops-item-tooltip']} data-testid="row-queryvalue">{queryValue}</p></CITooltip></div>}
        </Col>
        {isView ? <Col sm={2} /> : (
          <Col sm={2} className={classes.buttons}>
            {!editClicked ? (
              <span className={classes['edit-buttons']}>
                <CIActionBtnGroup
                  buttons={[
                    {
                      label: 'edit',
                      key: 'editIcon',
                      variant: 'tertiary',
                      onClick: async () => onEditQueryHandler(),
                      testId: 'edit-btn'
                    },
                    {
                      label: 'delete',
                      key: 'deleteIcon',
                      variant: 'tertiary',
                      onClick: async () => onDeleteQueryHandler(index),
                      testId: 'delete-btn'
                    }]}
                />
              </span>

            ) : (
              <div className={classes['check-buttons']}>
                <Button
                  variant="tertiary"
                  className={classes['update-button']}
                  disabled={!isUpdateQueryBtnEnabled()}
                  onClick={() => onUpdateQueryHandler(index)}
                  data-testid="update-btn"
                  aria-label="update-btn"
                >
                  <MyIcon name="thinCheckIcon" />
                </Button>
                <Button
                  variant="tertiary"
                  onClick={() => onCancelQueryHandler()}
                  data-testid="cancel-btn"
                  className={classes['cancel-button']}
                  aria-label="cancel-btn"
                >
                  <MyIcon name="xMarkLargeIcon" />
                </Button>
              </div>
            )}
          </Col>)}
      </Row>
    </div>);
};
export default ServiceOperationQueryItem;
